import AES from "crypto-js/aes";
import enc from "crypto-js/enc-utf8";
import CryptoJS from "crypto-js";

export function encrypt(text, key) {
  return AES.encrypt(text, key).toString();
}
export function decrypt(chiper = "", key) {
  return AES.decrypt(chiper.toString(), key).toString(enc);
}

// Decrypts AES-256-CBC ciphertext produced by the backend (OpenSSL EVP_BytesToKey).
// base64String: base64-encoded JSON { ct, iv, s }
// Returns plaintext string, or null on any error.
export function decryptFromBE(passphrase, base64String) {
  try {
    const jsonStr = atob(base64String);
    const { ct, iv, s } = JSON.parse(jsonStr);

    const salt = CryptoJS.enc.Hex.parse(s);
    const pass = CryptoJS.enc.Utf8.parse(passphrase);

    // EVP_BytesToKey: accumulate MD5 rounds until 48 bytes derived
    let dx = CryptoJS.lib.WordArray.create([]);
    let derived = CryptoJS.lib.WordArray.create([]);
    while (derived.sigBytes < 48) {
      dx = CryptoJS.MD5(dx.concat(pass).concat(salt));
      derived = derived.concat(dx);
    }

    // First 32 bytes = AES-256 key
    const key = CryptoJS.lib.WordArray.create(derived.words.slice(0, 8), 32);

    const cipherParams = CryptoJS.lib.CipherParams.create({
      ciphertext: CryptoJS.enc.Base64.parse(ct),
    });

    const decrypted = CryptoJS.AES.decrypt(cipherParams, key, {
      iv: CryptoJS.enc.Hex.parse(iv),
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });

    return decrypted.toString(CryptoJS.enc.Utf8);
  } catch (e) {
    return null;
  }
}
